import React, {useEffect, useState} from 'react';
import {CodeIdType, CodeType, UserIdType, UserType} from "../../../constant/CodeSpecNum";
import {useNavigate} from "react-router-dom";
import Th_title from "../../../components/Th_title";
import {useDispatch, useSelector} from "react-redux";
import {saveServiceApply} from "../../../api/serviceRequest/ServiceApplyService";
import {resetContents} from "../../../redux/slice/contentSlice";
import ApprovalComponent from "../../settings/approval/new/ApprovalComponent";
import {getApprovalProcessSubmitPayload, clearApprovalProcessState, preloadApprovalProcesses} from "../../settings/approval/shared/approvalProcessStore";
import {getServiceCode} from "../../../api/serviceCode/ServiceCodeService";
import {validation} from "../serviceRequest/serviceUtils";
import {useTranslation} from "react-i18next";
import {onCreateIdClickListener} from "../../../components/commonmethod/simmsDrawerMethod";
import Selector from "../../../components/selector/Selector";
import SimmsDatePicker from "../../../components/datepicker/SimmsDatePicker";
import {dateOnChange} from "../../../components/commonmethod/simmsDateMethod";
import dayjs from "dayjs";
import SimmsInput from "../../../components/input/SimmsInput";
import {inputOnChange} from "../../../components/commonmethod/simmsInputMethod";
import SimmsTextArea from "../../../components/input/SimmsTextArea";
import SimmsInputSearch from "../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../components/drawer/simms/SimmsDrawerSearch";
import {
    ContentDetailThreeColLayout,
    DetailFilePanel,
    DetailKvReadOnly,
    DetailKvTable,
    DetailFormPageShell,
    DetailListPage,
    DetailPanel,
    DetailSummaryButton,
} from "../../../components/detailLayout";
import "../../../components/detailLayout/detailListLayout.css";

const ServiceApplyCreate = () => {
    const [serviceApply, setServiceApply] = useState({
        title: null, requestCloseDate: null, serviceCode: null, approvalProcessId: null
    });
    const [docs, setDocs] = useState([]);
    const navigate = useNavigate();
    const {t} = useTranslation();
    const user = useSelector(state => state.auth.user);
    const approvalProcessId = useSelector((state) => state.content.approvalProcess?.id);
    const currentDate = new Date();

    const dispatch = useDispatch();

    useEffect(() => {
        clearApprovalProcessState(dispatch);
        return () => {
            clearApprovalProcessState(dispatch);
            dispatch(resetContents());
        };
    }, [dispatch]);

    useEffect(() => {
        if (!serviceApply.serviceCodeId) {
            clearApprovalProcessState(dispatch);
            return;
        }

        void getServiceCode(serviceApply.serviceCodeId, (data) => {
            if (data?.approvalProcess?.id) {
                preloadApprovalProcesses(dispatch, {beforeId: data.approvalProcess.id});
            } else {
                clearApprovalProcessState(dispatch);
            }
        });
    }, [dispatch, serviceApply.serviceCodeId]);

    const create = async () => {
        const validationData = {
            serviceCodeId: serviceApply.serviceCodeId,
            applierId: serviceApply.applierId,
            requestCloseDate: serviceApply.requestCloseDate,
            title: serviceApply.title,
        }
        if (!validation(validationData, t)) return;

        const data = {
            ...serviceApply,
            ...getApprovalProcessSubmitPayload(),
        }
        const files = docs.map(doc => doc.object);
        await saveServiceApply(data, files, (id) => {
            alert(t(`saved`));
            navigate(`/serviceRequest/serviceApply/${id}`);
        });
    }

    const requestInfoPanel = (
        <DetailPanel title={"기본정보"}>
            <DetailKvTable>
                <tbody>
                <tr>
                    <Th_title title={"요청제목"} colspan={3} className="fieldset-td" required auth>
                        <SimmsInput
                            onChange={(v)=> inputOnChange(setServiceApply,"title", v, true)}
                            data={serviceApply.title} />
                    </Th_title>
                </tr>
                <tr className="asset-detail-kv-row--auto">
                    <Th_title title={"요청내용"} colspan={3} className="fieldset-td" auth>
                        <SimmsTextArea
                            onChange={(v)=> inputOnChange(setServiceApply,"description", v, true)}
                            data={serviceApply.description} style={{minHeight:"100px"}}/>
                    </Th_title>
                </tr>
                <tr>
                    <DetailKvReadOnly
                        label="등록일시"
                        value={currentDate.toISOString()}
                        type="date"
                    />
                    <DetailKvReadOnly label="수정일시" value=""/>
                </tr>
                <tr>
                    <DetailKvReadOnly label="등록자" value={user?.name}/>
                    <DetailKvReadOnly label="수정자" value=""/>
                </tr>
                <tr>
                    <Th_title title={"요청코드"} colspan={3} className="fieldset-td" required auth>
                        <Selector
                            onChange={(value)=> onCreateIdClickListener(
                                setServiceApply, CodeType.serviceCode, CodeIdType.serviceCodeId,
                                serviceApply.serviceCode, value
                            )}
                            data={serviceApply.serviceCode}
                            entity={"serviceCode"}
                            uniqueKey={CodeType.serviceCode}
                            recursive auth
                        />
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title={"요청자"} colspan={3} className="fieldset-td fieldset-td-input" required auth>
                        <Selector
                            onChange={(value)=> onCreateIdClickListener(
                                setServiceApply, UserType.applier, UserIdType.applierId, serviceApply.applier, value
                            )}
                            data={serviceApply.applier}
                            uniqueKey={UserType.applier}
                            entity={"userAccount"} auth
                        >
                            <SimmsInputSearch type={'TEXT'} placeHolder={"사용자명"} />
                            <SimmsDrawerSearch showLabel title={'부서'} entity={'department'} target={'department'} recursive />
                            <SimmsDrawerSearch showLabel title={'업체'} entity={'company'} target={'company'} />
                        </Selector>
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title={"요청마감일"} colspan={3} className="fieldset-td" required auth>
                        <div>
                        <SimmsDatePicker onChange={(v)=> dateOnChange(setServiceApply,"requestCloseDate", v, true)}
                                         constraint={{largerThan : dayjs(new Date()), required: true}}
                                         data={serviceApply.requestCloseDate} auth/>
                        </div>
                    </Th_title>
                </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );

    const asidePanel = (
        <>
            <ApprovalComponent auth approvalProcessId={approvalProcessId}/>
            <DetailFilePanel
                pendingFiles={{files: docs, setFiles: setDocs}}
                pendingInputId="service_apply_pending_doc"
            />
        </>
    );

    return (
        <DetailFormPageShell
            className="common-container container-height-full border-l-gray create-page detail-list-layout asset-detail-list-layout"
            title="서비스 신청 등록"
            meta="신규 서비스 신청 정보를 입력하세요"
            actions={
                <>
                    <DetailSummaryButton muted onClick={() => navigate("/serviceRequest/serviceApply")}>
                        취소
                    </DetailSummaryButton>
                    <DetailSummaryButton
                        onClick={() => {
                            if (window.confirm("등록 하시겠습니까?")) {
                                create();
                            }
                        }}
                    >
                        등록
                    </DetailSummaryButton>
                </>
            }
        >
            <DetailListPage isEditing className="flex min-h-0 flex-1 flex-col">
                <div className="container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col overflow-hidden">
                    <ContentDetailThreeColLayout
                        primary={requestInfoPanel}
                        secondary={null}
                        aside={asidePanel}
                    />
                </div>
            </DetailListPage>
        </DetailFormPageShell>
    );
};

export default ServiceApplyCreate;
